// extracted by mini-css-extract-plugin
export var container = "_mk-0";
export var dotAnimation = "_mk-2";
export var dotsLoading = "_mk-1";